import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";

export const GlobalFilter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter);
  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 500);
  return (
    <div className="mb-3 d-flex border pl-3 pt-3.5 pb-3.5 rounded-md text-2xl text-lightgray">
      <div class="input-group">
        <span class="input-group-text" id="inputGroup-sizing-default text-lightgray font-size-small">
          Search:{" "}
        </span>
        <input
          value={value || ""}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          type="text"
          class="form-control font-size-small focus:outline-none"
          aria-label="Sizing example input"
          aria-describedby="inputGroup-sizing-default"
        />
      </div>
      {/* <strong className="bg-info me-2">Global Search</strong> */}
    </div>
  );
};